export default "__VITE_ASSET__BJuce46u__"